<template>
  <component
    class="custom-overlay"
    :class="overlayClass"
    :style="overlayStyle"
    :is="type"
    v-if="value">
    <slot>
    </slot>
  </component>
</template>

<script>
import { colorShiftHelpers } from '../../mixins/helpers'

export default {
  props: {
    value: {
      default: true,
      type: Boolean
    },
    dark: {
      default: false,
      type: Boolean
    },
    absolute: {
      default: false,
      type: Boolean
    },
    color: {
      type: String
    },
    opacity: {
      default: 0.46,
      type: [Number, String]
    },
    type: {
      default: 'div',
      type: String
    },
    zIndex: {
      default: 5,
      type: [Number, String]
    },
    showOnHover: {
      default: false,
      type: Boolean
    }
  },
  mixins: [colorShiftHelpers],
  computed: {
    bgColor({ color, dark }) {
      return color ? color : dark ? 'rgb(23, 30, 38)' : 'rgb(245, 245, 245)'
    },
    overlayClass({ showOnHover }) {
      return {
        'show-on-hover': showOnHover
      }
    },
    overlayStyle({ absolute, bgColor, opacity, zIndex }) {
      return {
        position: absolute ? 'absolute' : 'fixed',
        background: this.addAlpha(bgColor, opacity),
        'z-index': zIndex
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-overlay {
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  &.show-on-hover {
    opacity: 0;
    transition: opacity .3s ease;
    &:hover {
      opacity: 1;
    }
  }
}
</style>
